<template>
  <div id="index">
    <div class="visible-xs min_index">
      <header class="flex_center m_header">
        <i class="esc" @click="goBackward"><img src="@/assets/img/esc_fan.png" alt="" /></i>
        <h4 class="header_title">麻醉眼界</h4>
      </header>
      <!-- 报名表单 -->
      <div class="activitiesList">作品列表<span class="prompt">（为自己喜欢的作品投票吧，一次点赞即为一票）</span></div>
      <div class="list_ul">
        <div class="list_li" v-for="(liem, index) in list" :key="index" @click.stop="detailsFun(liem)">
          <div class="li_top flex_start flex_items">
            <i class="cover_img portrait flex_center"><img :src="liem.image" alt="" /></i>
            {{ liem.name }}
          </div>
          <div class="li_title clamp1">{{ liem.title }}</div>
          <div class="flex_between li_center">
            <div class="li_center_left clamp4">
              <span class="li_tag flex_center">{{ liem.activity_id }}号</span>
              {{ liem.content }}
            </div>
            <i class="flex_center li_center_right"><img :src="liem.cover" alt=""></i>
          </div>
          <div class="flex_start li_bottm flex_items">
            <div class="flex_center botton_li" @click.stop="giveFun(index)">
              <span class="prompt">投票</span>
              <i><img v-if="liem.is_goods == 0" src="@/assets/img/give.png" alt="">
                <img v-else src="@/assets/img/give_t.png" alt=""></i>
              {{ liem.goods }}
            </div>
            <div class="flex_center botton_li">
              <i><img src="@/assets/img/pinglunP.png" alt=""></i>
              {{ liem.comment ? liem.comment : 0 }}
            </div>
          </div>
        </div>
        <div class="complete list_center" v-if="list.length<=0">
          <span v-if="!is_loading"> 加载中</span>
          <span v-else>暂无数据</span>
        </div>

      </div>
    </div>
    <!-- 提示注册弹窗 -->
    <LoginPrompt @promptFun="promptFun" ref="prompt"></LoginPrompt>
  </div>
</template>

<script>
  import "@/assets/js/currency.js";
  import "@/assets/css/reset.css";
  import "@/assets/css/pcsinaFaceAndEffec.css";
  import LoginPrompt from "@/components/assembly/LoginPrompt.vue"; //注册弹窗模块
  export default {
    name: "activitiesList",
    data() {
      return {
        list: [],
        page: 1,
        is_loading: false,
      };
    },
    computed: {},
    components: {
      LoginPrompt
    },
    props: {},
    watch: {},
    methods: {
      promptFun() {//提示弹窗回调
        this.$store.commit('queryUrl', '/m_activityList?id=' + this.id)
        this.$router.replace({ path: '/m_password', query: {} });
      },
      giveFun(index) {
        let that = this;
      if (!this.USER() || this.USER().length == 0) {
          this.$refs.prompt.popupFun();
          return false;
        }
        this.$post("activity-goods", {
          activity_id: this.list[index].activity_id,
          member_id: this.USER().id,
        }).then((res) => {
          if (res.data) {
            layer.open({
              content: "点赞成功",
              time: true,
              skin: "msg",
            });
            that.list[index].goods = that.list[index].goods + 1;
            that.list[index].is_goods = 1;
          }
        }).catch(error => {
          layer.open({
            content: error.message,
            time: 2,
            skin: "msg"
          });
        });
      },
      detailsFun(liem) {
        // if (!this.USER() || this.USER() == {}) {
        //   this.$refs.prompt.popupFun();
        //   return false;
        // }
        this.$router.push({ path: '/m_activityDetails', query: { id: liem.activity_id } });
      },
      goBackward() { //返回上一页
        if (window.history.length > 2) {
          this.$router.go(-1)
        } else {
          this.$router.replace('/m_home');
        }
      },
      //   获取列表
      getList() {
        let that = this;
        this.is_loading = false;
        if (this.page == 1) {
          this.list = [];
        }
        this.$post("activity-lists", {
          limit: 10,
          page: this.page,
          member_id: this.USER().id,
        }).then((res) => {
          that.is_loading = true;
          if (res.data.data) {
            res.data.data.forEach((element, index) => {
              res.data.data[index].cover = element.cover.split(",");
            });
            that.list = that.list.concat(res.data.data);
          }
        });
      },
      getDetails() {
        //获取详情
        let that = this;
        this.$post("index-view", { id: this.id }).then((res) => {
          that.activity = res.data;
          that.getShare(that.activity.title, that.activity.cover ? that.details.cover : '');
        });
      },
    },
    created() { },
    mounted() {
      this.id = this.$route.query.id;
      this.getList();
      this.getDetails();
      if (this._isMobile()) {

      } else {
        // alert("pc端");
        this.$router.push({ path: '/pc_activity', query: { id: this.id } });
      }
      let that = this;
      $(window).scroll(function () {
        var scrollTop = $(this).scrollTop();
        var scrollHeight = $(document).height();
        var windowHeight = $(this).height();
        if (scrollTop + windowHeight + 2 >= scrollHeight) {
          that.page++;
          that.getList();
        }
      });
    },
  };
</script>
<style>
</style>
<style scoped>
  #index {
    min-height: 100vh;
    background: #F6F6F6;
  }

  #index .min_index {
    padding-top: 45px;
  }

  .activitiesList {
    width: calc(100% - 3rem);
    line-height: 4.9rem;
    padding-left: 3rem;
    font-size: 1.8rem;
    font-weight: bold;
    background: #f6f6f6;
    color: #2b2b2b;
    box-shadow: 0.2rem 0 0.8rem rgba(70, 69, 69, 0.1);
  }

  .prompt {
    font-size: 1.2rem;
    font-weight: normal;
    color: #707070;
  }

  /* 列表 */
  .list_li {
    background: #fff;
    width: calc(100% - 5.4rem);
    margin: 1.5rem auto;
    padding: .4rem 1.4rem;
  }

  .list_li .li_top {
    font-size: 1.5rem;
    color: #888888;
    padding: .7rem 0;
  }

  .list_li .li_top i {
    width: 2.7rem;
    height: 2.7rem;
    border-radius: 50%;
    margin-right: .9rem;
    overflow: hidden;
  }

  .li_title {
    font-size: 1.8rem;
    color: #2B2B2B;
    padding: .7rem 0;
    font-weight: bold;
  }

  .li_center {
    height: 8rem;
    margin: .7rem 0;
    align-items: flex-start;
  }

  .li_center .li_center_left {
    font-size: 1.5rem;
    color: #888888;
    flex: 1;
  }

  .li_center .li_center_left .li_tag {
    width: 4.9rem;
    height: 2.1rem;
    border-radius: .5rem;
    background: #EC865B;
    color: #fff;
    display: inline-flex;
    font-size: 1.1rem;
  }

  .li_center .li_center_right {
    width: 11.2rem;
    height: 100%;
    border-radius: .5rem;
    overflow: hidden;
    margin-left: 1rem;
  }

  .li_bottm {
    height: 4rem;
    border-top: .05rem dashed #f1f1f1;
  }

  .li_bottm .botton_li {
    font-size: 1.4rem;
    margin-left: 1rem;
    color: #888;
  }

  .li_bottm .botton_li>i {
    width: 1.4rem;
    height: 1.4rem;
    margin-right: .6rem;
    white-space: nowrap;
  }

  .botton_li .prompt {
    font-size: 1.2rem;
    color: #777;
    margin-right: .5rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/minActivity/m_activityList.vue